var createGetFormInitialValues = function createGetFormInitialValues(_ref) {
  var getIn = _ref.getIn;
  return function (form) {
    var getFormState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (state) {
      return getIn(state, 'form');
    };
    return function (state) {
      return getIn(getFormState(state), form + '.initial');
    };
  };
};

export default createGetFormInitialValues;


//////////////////
// WEBPACK FOOTER
// ./~/redux-form/es/selectors/getFormInitialValues.js
// module id = 1579
// module chunks = 0